var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-height bg-white" },
    [
      _c("q-card-title", { staticClass: "text-center bg-primary text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("statistics")) + "\n    ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        { staticClass: "relative-position full-height q-my-md" },
        [
          _c("div", { staticClass: "row" }, [
            _vm.clientModules.has_courses
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_group_trainings_published) +
                        " " +
                        _vm._s(_vm.$t("published_trainings")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_courses
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_group_trainings_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_group_training_progress +
                          "% / " +
                          _vm.$t("average") +
                          ": " +
                          _vm.avg_group_trainings_certified +
                          "%"
                      },
                      model: {
                        value: _vm.qty_group_trainings_certified,
                        callback: function($$v) {
                          _vm.qty_group_trainings_certified = $$v
                        },
                        expression: "qty_group_trainings_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.clientModules.has_trails
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_trails_published) +
                        " " +
                        _vm._s(_vm.$t("published_trails")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_trails
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_trails_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_trails_progress +
                          "%"
                      },
                      model: {
                        value: _vm.qty_trails_certified,
                        callback: function($$v) {
                          _vm.qty_trails_certified = $$v
                        },
                        expression: "qty_trails_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.clientModules.has_presential
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_presential_published) +
                        " " +
                        _vm._s(_vm.$t("published_presentials")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_presential
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_presential_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_presential_progress +
                          "%"
                      },
                      model: {
                        value: _vm.qty_presential_certified,
                        callback: function($$v) {
                          _vm.qty_presential_certified = $$v
                        },
                        expression: "qty_presential_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.clientModules.has_live_classes
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_live_classes_published) +
                        " " +
                        _vm._s(_vm.$t("published_live_classes")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_live_classes
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_live_classes_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_live_classes_progress +
                          "%"
                      },
                      model: {
                        value: _vm.qty_live_classes_certified,
                        callback: function($$v) {
                          _vm.qty_live_classes_certified = $$v
                        },
                        expression: "qty_live_classes_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.clientModules.has_webcasts
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_webcasts_published) +
                        " " +
                        _vm._s(_vm.$t("published_webcasts")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_webcasts
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_webcasts_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_webcasts_progress +
                          "%"
                      },
                      model: {
                        value: _vm.qty_webcasts_certified,
                        callback: function($$v) {
                          _vm.qty_webcasts_certified = $$v
                        },
                        expression: "qty_webcasts_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.clientModules.has_podcasts
              ? _c(
                  "div",
                  { staticClass: "col-12 q-subheading text-weight-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.statistics.qty_podcasts_published) +
                        " " +
                        _vm._s(_vm.$t("published_podcasts")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm.clientModules.has_podcasts
              ? _c(
                  "div",
                  {
                    class: _vm.$q.platform.is.mobile
                      ? "col-10 offset-1"
                      : "col-12"
                  },
                  [
                    _c("q-slider", {
                      attrs: {
                        min: 0,
                        step: 1,
                        max: _vm.qty_podcasts_published,
                        label: "",
                        "label-always": "",
                        readonly: "",
                        "label-value":
                          _vm.$t("progress") +
                          ": " +
                          _vm.user_podcasts_progress +
                          "%"
                      },
                      model: {
                        value: _vm.qty_podcasts_certified,
                        callback: function($$v) {
                          _vm.qty_podcasts_certified = $$v
                        },
                        expression: "qty_podcasts_certified"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }